const NS = 'BlockoutValidationService';


export default class BlockoutValidationService {
    static isYearlyDayValid(blockoutYearlyDay: string | number, yearlyMonth: string) : boolean {
        if (!blockoutYearlyDay || !yearlyMonth) return false;
        const validatingYearlyDayStr = (typeof blockoutYearlyDay !== 'string' ? blockoutYearlyDay.toString() : blockoutYearlyDay);

        const validateYearDay = parseInt(validatingYearlyDayStr);
        const selectedMonth = parseInt(yearlyMonth);
        let valid = false;
    
        if (validateYearDay === parseFloat(validatingYearlyDayStr) && validatingYearlyDayStr.indexOf('.') === -1 && validatingYearlyDayStr.indexOf(',') === -1) {
            if (selectedMonth == 0 || selectedMonth == 2 || selectedMonth == 4 || selectedMonth == 6 || selectedMonth == 7 || selectedMonth == 9 || selectedMonth == 11) {
                valid = (validateYearDay >= 1 && validateYearDay <= 31);
            } else if (selectedMonth == 3 || selectedMonth == 5 || selectedMonth == 8 || selectedMonth == 10) {
                valid = (validateYearDay >= 1 && validateYearDay <= 30);
            } else {
                valid = (validateYearDay >= 1 && validateYearDay <= 28);
            }
        } else {
            valid = false;
        }
    
        return valid;
      }
}


